import { http } from '../http'
import { mockGetUsage } from '@/mocks/authMock'

export async function getUsage() {
	// MOCK
	if (import.meta.env.VITE_AUTH_MOCK) {
		return mockGetUsage()
	}
	return http.get('/usage').then((response) => response.data)
}
